import axios from 'axios'
/**
 * Initial state
 */
export const state = {
  devices: null,
}

/**
 * Mutations
 */
export const mutations = {
  ['SET_DEVICES'](state, devices) {
    devices = Devices.analyze(devices);
    Devices.store(devices);
    state.devices = devices
  },
  ['SET_DEVICES_FAILURE'](state) {
    state.devices = null
  },
  ['SET_DEVICE'](state, data) {
    state.devices[data[0].slug] = Devices.analyzeItem(data[0], data[1]);
    Devices.store(state.devices);
  },
  ['UNSET_DEVICE'](state, slug) {
    Vue.delete(state.devices, slug)
    Devices.store(state.devices);
  },
}

/**
 * Actions
 */
export const actions = {

  async fetchDevices({ commit }) {
    localStorage.removeItem('mydata');
    axios.get(`/api/switch/`).then(res => {
      if (res.data) {
        commit('SET_DEVICES', res.data)
      }
    }).catch(err => {
      commit('SET_DEVICES_FAILURE')
      console.error(err);
    });
  },
  async fetchDevice({ commit }, device) {
    localStorage.removeItem('mydata');
    axios.get(`/api/switch/get?slug=${device}`).then(res => {
      if (res.data) {
        commit('SET_DEVICE', [res.data.device, true])
      }
    }).catch(err => {
      console.error(err);
    });
  },
  setDevice({commit}, device) {
    commit('SET_DEVICE', [device, false])
  },
  modifyDevice({commit}, data) {
    let action = data.action ? data.action :'modify';
    axios.post(
      `/api/switch/${data.slug}/${action}`,
      data.modify
    ).then(res => {
      if (res.data.success) {
        if (action === 'delete') {
          commit('UNSET_DEVICE', data.slug)
        } else {
          commit('SET_DEVICE', [res.data.success, true])
        }
      }
    }).catch(err => {
      console.error(err);
    });
  },
}

/**
 * Getters
 */
export const getters = {
  devices: state => {
    if (state.devices) {
      return state.devices
    } else {
      return Devices.get();
    }
  },
  devicesCount: (state, getters) => {
   return getters.devices ? Object.keys(getters.devices).length : null
  },
  device: (state) => (slug) => {
    return state.devices ? state.devices[slug] : Devices.get()[slug]
  },
}
